import * as React from 'react';
import * as Lockr from 'lockr';

import { BaseHamburgerTab } from './BaseHamburgerTab';
import { DebugState, DebugStore } from '../../stores/DebugStore';
import { HamburgerTab } from '../../constants/Enums';
import { DebugActions } from '../../actions/DebugActions';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { UIHelper } from '../../utils/UIHelper';
import { GlobalHelper } from '../../utils/GlobalHelper';
import { DesktopSelect } from '../DesktopSelect';
import { UICoreButton } from '../UICoreButton';
import { i18n } from '../..';

import * as AppFileApiWrapper from '../../submodules/app-api/Filesystem/Wrapper';
import { loadScript } from '../../submodules/utils/Helper';
import { registerLogHandler, BaseMessage } from '../../submodules/app-api/Communication';

export class DebugTab extends BaseHamburgerTab<DebugState> {
    protected previous: HamburgerTab = HamburgerTab.MENU;

    public componentWillMount(): void {
        this.addStoreListener(DebugStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        return (
            <div className={this.getCSSClass()}>
                <div className="hamburger-tab-content scrollbar-wcf">
                    {this.header()}
                    <div className="hamburger-subheader">{this.state.id ? 'Session: ' + this.state.id : ''}</div>
                    <DesktopSelect
                        title={'Network requests'}
                        options={[
                            {key: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleNetworkRequests},
                            {key: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleNetworkRequests}
                        ]}
                        toggle={'active'}
                        id="debug-nw-select"
                        value={this.state.network_requests}
                    />
                    <DesktopSelect
                        title={'APP API'}
                        options={[
                            {key: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleAppMessage},
                            {key: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleAppMessage}
                        ]}
                        toggle={'active'}
                        disabled={true}
                        id="debug-am-select"
                        value={this.state.app_msg}
                    />
                    <DesktopSelect
                        title={'Actions'}
                        options={[
                            {key: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleActions},
                            {key: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleActions}
                        ]}
                        toggle={'active'}
                        id="debug-actions-select"
                        value={this.state.actions}
                    />
                    <DesktopSelect
                        title={'Errors'}
                        options={[
                            {key: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleLogErrors},
                            {key: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleLogErrors}
                        ]}
                        toggle={'active'}
                        id="debug-log-errors-select"
                        value={this.state.log_errors}
                    />
                    <DesktopSelect
                        title={'Log console output'}
                        options={[
                            {key: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleConsoleLog},
                            {key: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleConsoleLog}
                        ]}
                        toggle={'active'}
                        disabled={this.state.log_to_console === 'true'}
                        id="debug-console-select"
                        value={this.state.console_log}
                    />
                    <DesktopSelect
                        title={'Log to browser console'}
                        options={[
                            {key: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleLogToConsole},
                            {key: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleLogToConsole}
                        ]}
                        toggle={'log_to_console'}
                        disabled={this.state.console_log === 'true'}
                        id="debug-log-to-console-select"
                        value={this.state.log_to_console}
                    />
                    <UICoreButton color="green" align="block" onClick={this.resetLockr} label="Reset all settings"/>
                    <UICoreButton color="green" align="block" onClick={this.deleteProjects} label="Delete all projects"/>
                    <UICoreButton color="green" align="block" onClick={this.showAdditionalInfo} label="Show additional information"/>
                    <UICoreButton color="green" align="block" onClick={this.closeEaiwsSession} label="Close EAIWS session"/>
                    <UICoreButton color="green" align="block" onClick={this.loadFirebugLite} label="Load Firebug Lite"/>
                    <UICoreButton color="green" align="block" onClick={this.registerAppApiLogHandler} label="Register App API log handler"/>
                </div>
            </div>
        );
    }

    protected getLabel(): string {
        return 'Debug';
    }

    protected toggleNetworkRequests = (): void => {
        DebugActions.updateSettings(jQuery.extend({}, this.state, {network_requests: this.state.network_requests === 'true' ? 'false' : 'true'}));
    };

    protected toggleActions = (): void => {
        DebugActions.updateSettings(jQuery.extend({}, this.state, {actions: this.state.actions === 'true' ? 'false' : 'true'}));
    };

    protected toggleLogErrors = (): void => {
        DebugActions.updateSettings(jQuery.extend({}, this.state, {log_errors: this.state.log_errors === 'true' ? 'false' : 'true'}));
    };

    protected toggleConsoleLog = (): void => {
        if (this.state.log_to_console !== 'true') {
            DebugActions.updateSettings(jQuery.extend({}, this.state, {console_log: this.state.console_log === 'true' ? 'false' : 'true'}));
        }
    };

    protected toggleLogToConsole = (): void => {
        if (this.state.console_log !== 'true') {
            DebugActions.updateSettings(jQuery.extend({}, this.state, {log_to_console: this.state.log_to_console === 'true' ? 'false' : 'true'}));
        }
    };

    protected toggleAppMessage = (): void => {
        if (false) {
            DebugActions.updateSettings(jQuery.extend({}, this.state, {app_msg: this.state.app_msg === 'true' ? 'false' : 'true'}));
        }
    };

    protected onChange = (): void => {
        this.setState(DebugStore.getState());
    };

    protected resetLockr = (): void => {
        UIHelper.ignoreReject(
            UIHelper.dialog('Delete all settings?', 'YES', 'NO').then((): void => {
                Lockr.flush();
            })
        );
    };

    protected deleteProjects = (): void => {
        UIHelper.ignoreReject(
            UIHelper.dialog('Delete all projects?', 'YES', 'NO').then((): void => {
                AppFileApiWrapper.list('/').then((files: Array<string>): void => {
                    files.map((path: string): void => {
                        AppFileApiWrapper.remove('/' + path);
                    });
                });
            })
        );
    };

    protected closeEaiwsSession(): void {
        UIHelper.ignoreReject(
            UIHelper.dialog('Close EAIWS Session?', 'YES', 'NO').then((): void => {
                GlobalHelper.eaiwsSession.close();
            })
        );
    }

    protected loadFirebugLite(): void {
        loadScript('https://getfirebug.com/firebug-lite.js#startOpened');
    }

    protected registerAppApiLogHandler(): void {
        registerLogHandler((msg: BaseMessage): void => {
            // tslint:disable-next-line:no-console
            console.log(msg);
        });
    }

    private showAdditionalInfo = async (): Promise<void> => {
        const content: string = [
            'Url: ' + window.location.href.toString(),
            'User-Agent: ' + window.navigator.userAgent.toString(),
            'Language: ' + window.navigator.language + ' (i18next: ' + i18n.language + ')',
            'EAIWS-Server: ' + GlobalHelper.eaiwsSession.baseUrl,
            'Mobile-Device: ' + (AppConfigurationStore.getState().mobileDevice ? 'yes' : 'no'),
            'Touch-Device: ' + (AppConfigurationStore.getState().touchDevice ? 'yes' : 'no'),
            'IDevice: ' + (AppConfigurationStore.getState().iDevice ? 'yes' : 'no'),
            'Android-Device: ' + (AppConfigurationStore.getState().os === 'AndroidOS' ? 'yes' : 'no')
        ].join('\r\n\r\n');

        UIHelper.dialog(
            <textarea style={{width: '100%', height: '200px'}} value={content} />,
            'Close'
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/DebugTab.tsx